<template>
  <SvgInteractionsListener :svg-url="svgUrl" :svg-data="svgData" />
</template>

<script>
import { mapGetters } from 'vuex'
import SvgInteractionsListener from '@/components/Gadgets/SvgInteractionsListener'

export default {
  name: 'NeighbourhoodSubdivisionInteractiveSvgLayer',
  components: {
    SvgInteractionsListener,
  },
  props: {
    svgUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      findNeighbourhoodSubdivisionById:
        'Topview/findNeighbourhoodSubdivisionById',
    }),
    neighbourhoodSubdivision() {
      const neighbourhoodSubdivisionId = this.$route.params
        .neighbourhoodSubdivisionId
      return this.findNeighbourhoodSubdivisionById(neighbourhoodSubdivisionId)
    },
    svgData() {
      return this.neighbourhoodSubdivision?.svgData
    },
  },
}
</script>
